import { render, staticRenderFns } from "./info.vue?vue&type=template&id=edc328ba&scoped=true"
import script from "./info.vue?vue&type=script&lang=js"
export * from "./info.vue?vue&type=script&lang=js"
import style0 from "./info.vue?vue&type=style&index=0&id=edc328ba&prod&lang=less"
import style1 from "./info.vue?vue&type=style&index=1&id=edc328ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc328ba",
  null
  
)

export default component.exports